// extracted by mini-css-extract-plugin
export var checkboxContainer = "pages-__DisputePurchase-module___checkboxContainer";
export var checkboxOverride = "pages-__DisputePurchase-module___checkboxOverride";
export var checkboxWrapper = "pages-__DisputePurchase-module___checkboxWrapper";
export var description = "pages-__DisputePurchase-module___description";
export var details = "pages-__DisputePurchase-module___details";
export var disclaimer = "pages-__DisputePurchase-module___disclaimer";
export var reason = "pages-__DisputePurchase-module___reason";
export var refundReason = "pages-__DisputePurchase-module___refundReason";
export var srOnly = "pages-__DisputePurchase-module___srOnly";
export var toggle = "pages-__DisputePurchase-module___toggle";